<template>
  <div class="docuform-details">
    <div class="tab_content">
      <h3 class="page-title">{{$t('client.matters.matter_page.docuforms_tab.details_page_title')}}</h3>
      <SkeletonText :loading="isLoading" >
        <DocuformDetailRow v-if="item.staff_name" :title="$t('client.matters.matter_page.docuforms_tab.details_label_staff')" :value="item.staff_name"/>
        <DocuformDetailRow :title="$t('client.matters.matter_page.docuforms_tab.details_label_file')" :value="item.metadata.file_name"/>
        <DocuformDetailRow :title="$t('client.matters.matter_page.docuforms_tab.details_label_created')" :value="item.created_at | date_and_hour"/>
        <DocuformDetailRow v-if="viewTime" :title="$t('client.matters.matter_page.docuforms_tab.details_label_viewed')" :value="viewTime | date_and_hour"/>
        <DocuformDetailRow v-if="downloadTime" :title="$t('client.matters.matter_page.docuforms_tab.details_label_downloaded')" :value="downloadTime | date_and_hour"/>
        <DocuformDetailRow v-if="approvedTime" :title="$t('client.matters.matter_page.docuforms_tab.details_label_approved')" :value="approvedTime | date_and_hour"/>
        <DocuformDetailRow v-if="rejectedTime" :title="$t('client.matters.matter_page.docuforms_tab.details_label_rejected')" :value="rejectedTime | date_and_hour"/>
        <DocuformDetailRow v-if="reuploadedAt" :title="$t('client.matters.matter_page.docuforms_tab.reuploaded_at')" :value="reuploadedAt | date_and_hour"/>
      </SkeletonText>
    </div>
  </div>
</template>

<script>
import DocuformDetailRow from './DocuformDetailRow';
import { SkeletonText } from '@/modules/common/components';
export default {
  name: "DocuformDetails",
  components: { SkeletonText, DocuformDetailRow },
  props: {
    item: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    viewTime() {
      return this.item.metadata?.viewed_at;
    },
    downloadTime() {
      return this.item.metadata?.downloaded_at;
    },
    approvedTime() {
      return this.item.metadata?.approved_on;
    },
    rejectedTime() {
      return this.item.metadata?.rejected_on;
    },
    reuploadedAt() {
      return this.item.metadata?.reuploaded_at;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform-details {
  min-height: 100%;
  padding: 12px 16px;

  @include md-and-up-main {
    padding: 24px;
  }

  .tab_content {
    background-color: #fff;
    padding: 24px;
    border: 1px solid $input-border;
    border-radius: 4px;
  }

  .page-title {
    color: $buttonBlackTextColor;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
  }
}

</style>
